import BiddingCampaignsResource from "./biddingCampaigns.resource";

const biddingCampaignsModule = angular
  .module("app.resources.biddingCampaigns", [])
  .service("BiddingCampaigns", BiddingCampaignsResource);

export default biddingCampaignsModule;



// WEBPACK FOOTER //
// ./src/resources/biddingCampaigns/biddingCampaigns.module.js